/**
 * Possible evaluation results
 */
export enum Evaluation {
  Correct = 'Correct',
  Incorrect = 'Incorrect'
}
